// Import model
import { DataviewMaterialAssignmentResponse } from '../models/DataviewMaterialAssignmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterMaterialAssignmentRequest } from '../models/FilterMaterialAssignmentRequest';
import { MaterialAssignment } from '../models/MaterialAssignment';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterMaterialAssignmentRequestSerializer } from './FilterMaterialAssignmentRequestSerializer';
import { MaterialAssignmentSerializer } from './MaterialAssignmentSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewMaterialAssignmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewMaterialAssignmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewMaterialAssignmentResponse instance
   */
  static deserialize(json: string): DataviewMaterialAssignmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewMaterialAssignmentResponse instance
   */
  static fromObject(obj: any): DataviewMaterialAssignmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewMaterialAssignmentResponse');
    }


    const instance: DataviewMaterialAssignmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        MaterialAssignmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterMaterialAssignmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewMaterialAssignmentResponse instances
   */
  static deserializeArray(json: string): DataviewMaterialAssignmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewMaterialAssignmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewMaterialAssignmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewMaterialAssignmentResponse instance to a plain object
   */
  static toObject(instance: DataviewMaterialAssignmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        MaterialAssignmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterMaterialAssignmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewMaterialAssignmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewMaterialAssignmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
